export { OrganisationInfoEditComponent } from './organisation-info-edit/organisation-info-edit.component';
export { OrganisationInfoViewComponent } from './organisation-info-view/organisation-info-view.component';
export { OrganisationInfoComponent } from './organisation-info.component';
export { OrganisationInfoModule } from './organisation-info.module';
